import Active from './Active/index.js';
import Aligned from './Aligned/index.js';
import Brand from './Brand/index.js';
import Default from './Default/index.js';
import FileType from './FileType/index.js';
import Filled from './Filled/index.js';
import RichTextEditor from './RichTextEditor/index.js';
const Icons = {
    // Icons with active boolean state
    ...Active,
    // Icons with alignment prop (ex. chevron with top, bottom)
    ...Aligned,
    // Brand logos used to represent companies or platforms (e.g. Google, Meta, Microsoft)
    ...Brand,
    // Static icons with no additional props
    ...Default,
    // Icons with filled boolean state
    ...Filled,
    // Rich text editor action icons
    ...RichTextEditor,
    // File type icons
    ...FileType,
};
export { Active, Aligned, Brand, Default, Filled, RichTextEditor, FileType };
export default Icons;
